var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.transport==='air'?'4': '6')+"才/40kg內 （1才=長*寬*高/27000) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }